import React from "react";
import moment from "moment";
import { useNavigate, useParams, Link } from "react-router-dom";
import { TailwindToaster } from "../../components";
import { toast } from "react-hot-toast";

import { useSelector } from "react-redux";
import axios from "../../api/axios";

const AddressBookEdit = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state.UserReducer);
  const { addressBookId } = useParams();
  const updateUrl = "/addressbook/" + addressBookId;
  const activeCRMUrl = "/user/active";

  const [crmData, setCRMData] = React.useState([]);
  const [addressBookDataFromServer, setAddressBookDataFromServer] =
    React.useState({});
  const [customerID, setCustomerID] = React.useState("0000");
  const [channel, setChannel] = React.useState("");
  const [validCustomerType, setCustomerTypeValidity] = React.useState(true);
  const [validFirstName, setFirstNameValidity] = React.useState(true);
  const [validChannel, setChannelValidity] = React.useState(true);
  const [validPhoneNumber, setPhoneNumberValidity] = React.useState(true);
  const [validCountryCode, setCountryCodeValidity] = React.useState(true);
  const [validEmail, setEmailValidity] = React.useState(true);
  const [countryCode, setCountryCode] = React.useState("91");

  const [dateOfBirthState, setDateOfBirth] = React.useState(
    moment().subtract(8, "years").format("yyyy-MM-DD"),
  );

  const getCRMOptions = () => {
    try {
      axios
        .get(activeCRMUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length > 0) {
            setCRMData(response.data.users);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const getAddressBook = () => {
    try {
      axios
        .get(updateUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.addressBook) {
            setAddressBookDataFromServer(response.data.addressBook);
            setCustomerID(response.data.addressBook.customerID);
            document.getElementById("prefix").value =
              response.data.addressBook?.prefix;
            document.getElementById("occupationType").value =
              response.data.addressBook?.occupationType;
            document.getElementById("contactTime").value =
              response.data.addressBook?.contactTime;
            document.getElementById("customerType").value =
              response.data.addressBook?.customerType;
            document.getElementById("channel").value =
              response.data.addressBook?.channel;
            // document.getElementById("countryCode").value =
            //   response.data.addressBook?.countryCode;
            document.getElementById("crm").value =
              response.data.addressBook?.crm?._id;
            setChannel(response.data.addressBook.channel);
            setCountryCode(response.data.addressBook.countryCode);
            if (response.data.addressBook?.dateOfBirth) {
              setDateOfBirth(
                response.data.addressBook?.dateOfBirth.slice(0, 10),
              );
            }
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    document.getElementById("dateOfBirth").value = dateOfBirthState;
  }, [dateOfBirthState]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getAddressBook();
    getCRMOptions();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    var canSubmit = true;
    const addressBookData = new FormData(event.target);

    setCustomerTypeValidity(true);
    setFirstNameValidity(true);
    setChannelValidity(true);
    setCountryCodeValidity(true);
    setPhoneNumberValidity(true);
    setEmailValidity(true);

    if (addressBookData.get("customerType") === "") {
      setCustomerTypeValidity(false);
      canSubmit = false;
    }

    if (addressBookData.get("firstName") === "") {
      setFirstNameValidity(false);
      canSubmit = false;
    }

    if (
      addressBookData.get("channel") === "Reference" &&
      addressBookData.get("referenceName") === ""
    ) {
      setChannelValidity(false);
      canSubmit = false;
    }

    if (
      addressBookData.get("phoneNumber") === "" ||
      addressBookData.get("phoneNumber").length < 10
    ) {
      setPhoneNumberValidity(false);
      canSubmit = false;
    }
    if (countryCode === "") {
      setCountryCodeValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }

    const dataToSubmit = {
      prefix: addressBookData.get("prefix"),
      customerType: addressBookData.get("customerType"),
      firstName: addressBookData.get("firstName"),
      lastName: addressBookData.get("lastName"),
      alternatePhone: addressBookData.get("alternatePhone"),
      countryCode,
      phoneNumber: addressBookData.get("phoneNumber"),
      email: addressBookData.get("email"),
      dateOfBirth: addressBookData.get("dateOfBirth"),
      addressLine1: addressBookData.get("addressLine1"),
      addressLine2: addressBookData.get("addressLine2"),
      city: addressBookData.get("city"),
      state: addressBookData.get("state"),
      country: addressBookData.get("country"),
      pincode: addressBookData.get("pincode"),
      channel: addressBookData.get("channel"),
      referenceName: addressBookData.get("referenceName"),
      contactTime: addressBookData.get("contactTime"),
      crm: addressBookData.get("crm"),
      crmReview: addressBookData.get("crmReview"),
      occupationType: addressBookData.get("occupationType"),
      occupiedIndustry: addressBookData.get("occupiedIndustry"),
      designation: addressBookData.get("designation"),
      vehicleUsed: addressBookData.get("vehicleUsed"),
      kidsCount: addressBookData.get("kidsCount"),
      miscellaneousInformation: addressBookData.get("miscellaneousInformation"),
      callSummary: addressBookData.get("callSummary"),
    };

    try {
      axios
        .put(updateUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            setTimeout(() => {
              navigate(-1);
            }, 800);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      //
    }
  };

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <form
                  action='#'
                  method='POST'
                  noValidate
                  onSubmit={(event) => {
                    handleSubmit(event);
                  }}>
                  <TailwindToaster />
                  <div className='shadow overflow-hidden sm:rounded-md'>
                    <div className='px-4 py-5 bg-gray-50 sm:p-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Edit Address Book - #
                            {addressBookDataFromServer?.customerID}
                          </h2>
                        </div>
                      </div>
                      <div className='mt-3 sm:mt-4 grid grid-cols-12 gap-3'>
                        <div className='col-span-4 sm:col-span-1'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700'>
                            Prefix*
                          </label>
                          <select
                            id='prefix'
                            name='prefix'
                            defaultValue={addressBookDataFromServer?.prefix}
                            className='mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value='Mr'>Mr</option>
                            <option value='Mrs'>Mrs</option>
                            <option value='Ms'>Ms</option>
                            <option value='Dr'>Dr</option>
                            <option value='Er'>Er</option>
                          </select>
                        </div>
                        <div className='col-span-8 sm:col-span-2'>
                          <label
                            htmlFor='firstName'
                            className={`block text-sm font-medium ${
                              !validFirstName ? "text-red-600" : "text-gray-700"
                            }`}>
                            First name*
                          </label>
                          <input
                            type='text'
                            name='firstName'
                            id='firstName'
                            maxLength='20'
                            defaultValue={addressBookDataFromServer?.firstName}
                            className={`mt-1 ${
                              !validFirstName
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                          {!validFirstName && (
                            <p className='text-red-600 text-sm'>
                              First Name invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='lastName'
                            className='block text-sm font-medium text-gray-700'>
                            Last name
                          </label>
                          <input
                            type='text'
                            name='lastName'
                            id='lastName'
                            defaultValue={addressBookDataFromServer?.lastName}
                            maxLength='20'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='contactTime'
                            className='block text-sm font-medium text-gray-700'>
                            Contact Time
                          </label>
                          <select
                            id='contactTime'
                            name='contactTime'
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value='Morning'>Morning</option>
                            <option value='Noon'>Noon</option>
                            <option value='Evening'>Evening</option>
                          </select>
                        </div>
                        <div className='col-span-5 sm:col-span-2'>
                          <label
                            htmlFor='customerType'
                            className={`block text-sm font-medium ${
                              !validCustomerType
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Customer Type*
                          </label>
                          <select
                            id='customerType'
                            name='customerType'
                            defaultValue={
                              addressBookDataFromServer?.customerType
                            }
                            className={`mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none ${
                              !validCustomerType
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            } sm:text-sm`}>
                            <option>Agent</option>
                            <option>Connector</option>
                            <option>Direct</option>
                            <option>Promoter</option>
                            <option>Drop</option>
                          </select>
                          {!validCustomerType && (
                            <p className='text-red-600 text-sm'>
                              Customer Type invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-7 sm:col-span-1'>
                          <label
                            htmlFor='countryCode'
                            className='block text-sm font-medium text-gray-700'>
                            Country Code*
                          </label>
                          <input
                            type='tel'
                            name='countryCode'
                            id='countryCode'
                            maxLength='5'
                            value={countryCode}
                            className={`mt-1 ${
                              !validCountryCode
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                            onChange={(e) => {
                              setCountryCode(e.target.value);
                            }}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='first-name'
                            className={`block text-sm font-medium ${
                              !validPhoneNumber
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Mobile#*
                          </label>
                          <input
                            type='tel'
                            name='phoneNumber'
                            id='phoneNumber'
                            defaultValue={
                              addressBookDataFromServer?.phoneNumber
                            }
                            maxLength='10'
                            className={`mt-1 ${
                              !validPhoneNumber
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                          {!validPhoneNumber && (
                            <p className='text-red-600 text-sm'>
                              Phone Number invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='first-name'
                            className={`block text-sm font-medium text-gray-700`}>
                            Alternate Phone
                          </label>
                          <input
                            type='tel'
                            name='alternatePhone'
                            id='alternatePhone'
                            defaultValue={
                              addressBookDataFromServer?.alternatePhone
                            }
                            maxLength='10'
                            className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-md`}
                          />
                          {!validPhoneNumber && (
                            <p className='text-red-600 text-sm'>
                              Phone Number invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='email'
                            className={`block text-sm font-medium ${
                              !validEmail ? "text-red-600" : "text-gray-700"
                            }`}>
                            Email ID
                          </label>
                          <input
                            type='email'
                            name='email'
                            id='email'
                            defaultValue={addressBookDataFromServer?.email}
                            maxLength='30'
                            className={`mt-1 ${
                              !validEmail
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                          {!validEmail && (
                            <p className='text-red-600 text-sm'>
                              Email invalid
                            </p>
                          )}
                        </div>
                      </div>
                      <div className='mt-10 lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Additional Information
                          </h2>
                        </div>
                      </div>
                      <div className='mt-3 sm:mt-4 grid grid-cols-12 gap-3'>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='dateOfBirth'
                            className='block text-sm font-medium text-gray-700'>
                            DOB
                          </label>
                          <input
                            type='date'
                            name='dateOfBirth'
                            defaultValue={dateOfBirthState}
                            id='dateOfBirth'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='channel'
                            className='block text-sm font-medium text-gray-700'>
                            Channel
                          </label>
                          <select
                            id='channel'
                            name='channel'
                            defaultValue={addressBookDataFromServer?.channel}
                            onChange={(event) => {
                              setChannel(event.target.value);
                              // if (["Reference","Agent",""].includes(event.target.value) ) {`

                              // } else {
                              //   setChannel(false);
                              // }
                            }}
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='99 acres'>99 acres</option>
                            <option value='Agent'>Agent</option>
                            <option value='BNI'>BNI</option>
                            <option value='Common Floor'>Common Floor</option>
                            <option value='Email'>Email</option>
                            <option value='Facebook'>Facebook</option>
                            <option value='Fieldwork'>Fieldwork</option>
                            <option value='Just Dial'>Just Dial</option>
                            <option value='Knowlarity'>Knowlarity</option>
                            <option value='Magic Bricks'>Magic Bricks</option>
                            <option value='Net Search'>Net Search</option>
                            <option value='Newspaper Ad'>Newspaper Ad</option>
                            <option value='Old Client'>Old Client</option>
                            <option value='Online Marketing'>
                              Online Marketing
                            </option>
                            <option value='On Site Board'>On Site Board</option>
                            <option value='Reference'>Reference</option>
                            <option value='Walk-in'>Walk-in</option>
                            <option value='Website'>Website</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        {["Reference", "Agent", "Others"].includes(channel) ? (
                          <div className={`col-span-12 sm:col-span-2`}>
                            <label
                              htmlFor='referenceName'
                              className={`block text-sm font-medium ${
                                !validChannel ? "text-red-600" : "text-gray-700"
                              }`}>
                              {channel === "Reference"
                                ? "Reference Name"
                                : channel === "Agent"
                                ? "Agent Name"
                                : "Others"}
                            </label>
                            <input
                              type='text'
                              name='referenceName'
                              id='referenceName'
                              maxLength='20'
                              defaultValue={
                                addressBookDataFromServer?.referenceName
                              }
                              className={`mt-1 ${
                                !validChannel
                                  ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                  : "focus:ring-yellow-2 focus:border-yellow-2"
                              }  block w-full shadow-sm sm:text-sm  rounded-md`}
                            />
                            {!validChannel && (
                              <p className='text-red-600 text-sm'>
                                Reference Name required
                              </p>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}

                        <div className='col-span-5 sm:col-span-2'>
                          <label
                            htmlFor='crm'
                            className='block text-sm font-medium text-gray-700'>
                            CRM
                          </label>
                          <select
                            id='crm'
                            name='crm'
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            {crmData?.length > 0 &&
                              crmData.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.fullname
                                    ? item.fullname
                                    : item.firstname}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div
                          className={`col-span-12 ${
                            ["Reference", "Agent", "Others"].includes(channel)
                              ? "sm:col-span-1"
                              : "sm:col-span-3"
                          }`}>
                          <label
                            htmlFor='crmReview'
                            className='block text-sm font-medium text-gray-700'>
                            CRM Review
                          </label>
                          <select
                            id='crmReview'
                            name='crmReview'
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Hot'>Hot</option>
                            <option value='Warm'>Warm</option>
                            <option value='Cold'>Cold</option>
                            <option value='Drop'>Drop</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='addressLine1'
                            className={`block text-sm font-medium text-gray-700`}>
                            Address Line 1
                          </label>
                          <input
                            type='text'
                            name='addressLine1'
                            id='addressLine1'
                            defaultValue={
                              addressBookDataFromServer?.addressLine1
                            }
                            maxLength='30'
                            className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='addressLine2'
                            className={`block text-sm font-medium text-gray-700`}>
                            Address Line 2
                          </label>
                          <input
                            type='text'
                            name='addressLine2'
                            id='addressLine2'
                            maxLength='30'
                            defaultValue={
                              addressBookDataFromServer?.addressLine2
                            }
                            className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='city'
                            className={`block text-sm font-medium text-gray-700`}>
                            City
                          </label>
                          <input
                            type='text'
                            name='city'
                            id='city'
                            defaultValue={addressBookDataFromServer?.city}
                            maxLength='30'
                            className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='state'
                            className={`block text-sm font-medium text-gray-700`}>
                            State
                          </label>
                          <input
                            type='text'
                            name='state'
                            id='state'
                            maxLength='30'
                            defaultValue={addressBookDataFromServer?.state}
                            className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor='country'
                            className={`block text-sm font-medium text-gray-700`}>
                            Country
                          </label>
                          <input
                            type='text'
                            name='country'
                            id='country'
                            defaultValue={addressBookDataFromServer?.country}
                            maxLength='30'
                            className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                        </div>

                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor='pincode'
                            className={`block text-sm font-medium text-gray-700`}>
                            Pincode
                          </label>
                          <input
                            type='text'
                            name='pincode'
                            id='pincode'
                            defaultValue={addressBookDataFromServer?.pincode}
                            maxLength='6'
                            className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                        </div>
                        <div className='col-span-5 sm:col-span-2'>
                          <label
                            htmlFor='occupatioType'
                            className='block text-sm font-medium text-gray-700'>
                            Occupation
                          </label>
                          <select
                            id='occupationType'
                            name='occupationType'
                            defaultValue={
                              addressBookDataFromServer?.occupationType
                            }
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option>Occupation</option>
                            <option value='Salaried'>Salaried</option>
                            <option value='Entrepreneur'>Entreprenuer</option>
                            <option value='Freelancer'>Freelancer</option>
                          </select>
                        </div>
                        <div className='col-span-7 sm:col-span-3'>
                          <label
                            htmlFor='occupiedIndustry'
                            className='block text-sm font-medium text-gray-700'>
                            Occupational Industry
                          </label>
                          <input
                            type='text'
                            name='occupiedIndustry'
                            id='occupiedIndustry'
                            defaultValue={
                              addressBookDataFromServer?.occupiedIndustry
                            }
                            maxLength='30'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='designation'
                            className='block text-sm font-medium text-gray-700'>
                            Designation
                          </label>
                          <input
                            type='text'
                            name='designation'
                            id='designation'
                            maxLength='30'
                            defaultValue={
                              addressBookDataFromServer?.designation
                            }
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='vehicleUsed'
                            className='block text-sm font-medium text-gray-700'>
                            Vehicle Used
                          </label>
                          <input
                            type='text'
                            name='vehicleUsed'
                            id='vehicleUsed'
                            defaultValue={
                              addressBookDataFromServer?.vehicleUsed
                            }
                            maxLength='30'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='kidsCount'
                            className='block text-sm font-medium text-gray-700'>
                            No. of Kids
                          </label>
                          <input
                            type='text'
                            name='kidsCount'
                            id='kidsCount'
                            defaultValue={addressBookDataFromServer?.kidsCount}
                            maxLength='30'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-6'>
                          <label
                            htmlFor='miscellaneousInformation'
                            className='block text-sm font-medium text-gray-700'>
                            Miscellaneous Information
                          </label>
                          <textarea
                            id='miscellaneousInformation'
                            name='miscellaneousInformation'
                            rows={3}
                            className='shadow-sm focus:ring-yellow-2 focus:border-yellow-2 mt-1 block w-full sm:text-sm border  rounded-md'
                            placeholder=''
                            defaultValue={
                              addressBookDataFromServer?.miscellaneousInformation
                            }
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-6'>
                          <label
                            htmlFor='callSummary'
                            className='block text-sm font-medium text-gray-700'>
                            Call Summary
                          </label>
                          <textarea
                            id='callSummary'
                            name='callSummary'
                            rows={3}
                            className='shadow-sm focus:ring-yellow-2 focus:border-yellow-2 mt-1 block w-full sm:text-sm border  rounded-md'
                            placeholder=''
                            defaultValue={
                              addressBookDataFromServer?.callSummary
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <Link
                            to='#'
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(-1);
                            }}
                            className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                            Discard
                          </Link>
                          <button
                            id='submitBtn'
                            type='submit'
                            className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                            Update
                          </button>
                        </div>
                      </div>
                      <div className='sm: py-2'></div>
                    </div>
                  </div>
                </form>
              </div>
              <div className='block md:hidden'>
                <div className='grid grid-cols-1 gap-4'></div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default AddressBookEdit;
